import React, { useRef, useState,useEffect } from "react"
import * as classNames from "./OngletCartesSection.module.scss"
import Card from "../../blocks/card/Card"
import Section from "../../../../core/layout/main/section/Section"
import Image from "../../blocks/image/Image"

const OngletCartesSection = ({
  ongletCartes,
  allCategoriesLabel,
  buttonText,
}) => {
  const uniqueLabels = Array.from(
    new Set(ongletCartes.map((item) => item.label))
  );
  const [activeTab, setActiveTab] = useState(allCategoriesLabel);
  const [filteredData, setFilteredData] = useState([...ongletCartes]);

  const updateFilteredData = () => {
    if (activeTab === allCategoriesLabel) {
      setFilteredData([...ongletCartes]);
    } else {
      setFilteredData(ongletCartes.filter((tab) => tab.label === activeTab));
    }
  };

  useEffect(() => {
    updateFilteredData();
  }, [activeTab, ongletCartes]);

  return (
    <div className={classNames.sectionStyle + " xxlarge"}>
      <div className={classNames.tabButtons}>
        <div className={classNames.tabbtnBg}>
        <button
              key={allCategoriesLabel}
              className={`${classNames.tabButton} ${
                activeTab === allCategoriesLabel ? classNames.active : ""
              }`}
              onClick={() => setActiveTab(allCategoriesLabel)}
            >
              {allCategoriesLabel}
            </button>
          {uniqueLabels.map((label) => (
            <button
              key={label}
              className={`${classNames.tabButton} ${
                activeTab === label ? classNames.active : ""
              }`}
              onClick={() => setActiveTab(label)}
            >
              {label}
            </button>
          ))}
          <span
            className={classNames.tabButton+"  "+classNames.SpanStyle}
            disabled
          ></span>
        </div>
      </div>
      <div className={classNames.cardSwitch}>
        <div key={"OngletCartesSection"} className={classNames.cardsContainer}>
          {filteredData.map((tab) => (
            <div key={tab.id} className={classNames.Card}>
              <Image
                dataSizesPreset={'gd'}
                formats={tab.linkCtaLink.itemData.attributes.seo?.image?.data?.attributes.formats}
                imgSrc={tab.linkCtaLink.itemData.attributes.seo?.image?.data?.attributes.url}
                imgAlt={tab.linkCtaLink.itemData.attributes.seo?.image?.data?.attributes.alternativeText}
                imgHeight="250"
                imgWidth="100%"
                loading="lazy"
                className={classNames.img + " centered"}
              />

              <div className={classNames.bottomContent}>
                <h3 className={`line-clamp-2 ${classNames.Header}`}>{tab.linkCtaLink.itemData.attributes.title ||
                    tab.linkCtaLink.itemData.attributes.seo.title}</h3>
                <p className={`line-clamp-2 ${classNames.jobHeader}`}>
                  {tab.linkCtaLink.itemData.attributes.description ||
                    tab.linkCtaLink.itemData.attributes.seo.description}
                </p>
                <a
                  href={tab.linkCtaLink.itemData.attributes.route}
                  className={"button classique secondary large"}
                  style={{ width: "100%" }}
                >
                  {buttonText}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

}

export const name = "OngletCartesSection"

export const init = (componentData, pageContext) => {
  return (
    <OngletCartesSection
      key={componentData.id}
      ongletCartes={componentData.cardList || []}
      allCategoriesLabel={componentData.allCategoriesLabel}
      buttonText={componentData.buttonText}
    />
  )
}

export default OngletCartesSection
